import {
  Button,
  ButtonSize,
  ButtonType,
  Checkbox,
  Dialog,
  MessageBox,
  MessageBoxStatus,
  Toast,
} from "@yy/tofu-ui-react";
import React, { useEffect, useState, useContext } from "react";
import fetcher, { paths } from "../../lib/fetcher";
import { HTTPService, sleep, thousandSeparator, HttpServiceMsg, UserRole } from "../../lib/util";
import { CheckUpgradeResult } from "../../models/CheckUpgradeResult";
import { useHistory, useLocation } from "react-router-dom";
import { ModalRoutes } from "./ModalSwitch";
import { AmountResult } from "../../models/AmountResult";
import { PaymentResult } from "../../models/PaymentResult";
import qs from "qs";
import { UserRoleContext } from "../../App";
import { UpgradeStarResult } from "../../models/UpgradeStarResult";
import { showBeStarGuildSuccessDialog } from "../Dialogs";
import { RegGuildResult } from "../../models/RegGuildResult";
import { ChannelIdContext } from "../ChannelIdContextWrap";
import { stat } from "../../lib/hooks/useHiidoPV";
import numeral from "numeral";

const BeStarModal = () => {
  const history = useHistory();
  const location = useLocation();
  const [check, setCheck] = useState(true);
  const [bailDialogVisible, setBailDialogVisible] = useState(false);
  // 公会近三个月的累计蓝钻流水, 新版好似没用到
  // const [guildAnchorDiamond, setGuildAnchorDiamond] = useState(0);
  const [deposit, setDeposit] = useState(0);
  const [upgradeAmount, setUpgradeAmount] = useState(0);
  const [accountInfoLoading, setAccountInfoLoading] = useState(true);
  const [orderLoading, setOrderLoading] = useState(false);
  const userRole = useContext(UserRoleContext);
  const [beStarGuildLoading, setBeStarGuildLoading] = useState(false);
  const [upgradeCode, setUpgradeCode] = useState(0);
  const { auto } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const a = useContext(ChannelIdContext);

  function getNeedPayStr() {
    const dis = 3000 - deposit;
    return dis < 0 ? "0.00" : thousandSeparator(dis);
  }

  const needPayStr = getNeedPayStr();
  const needPay = 3000 - deposit;

  // 查询保证金账户相关信息
  async function fetchAccountInfo() {
    try {
      setAccountInfoLoading(true);
      const { data } = (await fetcher.get(paths.amount)) as AmountResult;
      setDeposit(data.yy_cash_pledge ? parseFloat(data.yy_cash_pledge) : 0);
      setUpgradeAmount(data.upgradeAmount || 0);
    } finally {
      setAccountInfoLoading(false);
    }
  }

  function showFailMsgBoxWith(msg: string) {
    MessageBox({
      width: "500px",
      title: "成为星级公会失败",
      status: MessageBoxStatus.WARN,
      onCancel: () => history.replace(ModalRoutes.Root),
      showOk: false,
      cancelTxt: "知道了",
      desc: (
        <div style={{ textAlign: "center" }}>
          <p>{msg || "服务器异常, 请稍后重试"}</p>
        </div>
      ),
    });
  }

  async function beStarGuild() {
    // 数据上报
    stat.emit({ eventid: 20030927, act_type: "209" });

    setBeStarGuildLoading(true);
    // depositFlag 表示升级过程中有冻结保证金, TODO: 本次一共冻结3000块吗, 有小于3000的情况吗
    const { code, msg, depositFlag } = (await fetcher.get(paths.regStarGuild, {
      channelId: a || "0", // 默认'0'为自然流量
    })) as UpgradeStarResult;
    setBeStarGuildLoading(false);

    if (code === 0) {
      showBeStarGuildSuccessDialog(depositFlag);
      history.push(ModalRoutes.Root);
    } else if (code === 105) {
      MessageBox({
        title: "成为公会失败",
        status: MessageBoxStatus.FAIL,
        desc: '您未签署《公会服务协议》，不能直接成为公会',
        showOk: false,
        cancelTxt: "确定",
      })
      return;
    } else {
      showFailMsgBoxWith(msg);
    }
  }

  // 成为星级公会的前置校验，确保用户是否能够直接升星
  async function beforeCheck() {
    await sleep(300); // TODO: remove?

    // 普通用直接升星级
    if (userRole === UserRole.NormalUser) {
      const { code: codeNormal, msg: msgNormal } = (await fetcher.post(
        `${paths.regGuild}?channelId=${a || "0"}` // web 端自然流量为「0」
      )) as RegGuildResult;

      if (codeNormal === 104) { // SDK 账号
        MessageBox({
          title: "成为公会失败",
          status: MessageBoxStatus.FAIL,
          desc: '为YY百战直播公会身份，不能成为公会',
          showOk: false,
          onCancel: () => history.replace(ModalRoutes.Root),
          cancelTxt: "确定",
        })
        return;
      } else if (codeNormal === 105) {
        MessageBox({
          title: "成为公会失败",
          status: MessageBoxStatus.FAIL,
          desc: '您未签署《公会服务协议》，不能直接成为公会',
          showOk: false,
          cancelTxt: "确定",
        })
        return;
      } else if (codeNormal !== 0) {
        showFailMsgBoxWith(msgNormal);
        return;
      }
    }

    /**
     * code:
     *  首次 不满足 9
     *  再次 不满足保证金 10
     *  再次不满足 蓝钻 11
     */
    const { code, msg } = (await fetcher.get(paths.getStarGuildUpCondition)) as CheckUpgradeResult;

    if (code === HTTPService.Ok) {
      // 0 - 满足条件直接升级
      beStarGuild();
    } else if (code === 4) {
      // 4 - 被撤销, 需要一段时间后才能重新申请
      // msg 会返回 「您的星级公会被撤销，请于%s重新升级」
      showFailMsgBoxWith(msg);
    } else if (code === 9 || code === 10) {
      // 首次升级，但是旗下蓝钻收入不满足要求, 显示缴纳保证金弹窗
      // 设置公会近三个月的累计蓝钻流水
      // setGuildAnchorDiamond(guildAnchorDiamond ? parseFloat(guildAnchorDiamond) : 0);

      await fetchAccountInfo();
      setUpgradeCode(code);

      // TODO: 添加加载中的动效，太久了
      setBailDialogVisible(true);
    } else if (code === 11) {
      MessageBox({
        width: "500px",
        title: "当前蓝钻收入不满足成为星级公会条件",
        status: MessageBoxStatus.WARN,
        showOk: false,
        cancelTxt: "知道了",
        onCancel: () => history.replace(ModalRoutes.Root),
        desc: (
          <div className="cannotUpgrade-messagebox">
            <p>因您本月从星级公会降为普通公会，申请星级需满足以下条件</p>
            <ol>
              <li>申请时需满足旗下主播近3个自然月蓝钻流水≥¥0.3万</li>
              <li>需缴纳3000元保证金</li>
            </ol>
          </div>
        ),
      });
    } else {
      showFailMsgBoxWith(msg);
    }
  }

  useEffect(() => {
    if (auto === "1") {
      // 如果是自动的，直接调用升级的接口
      beStarGuild();
    } else {
      // 否则调用前置校验
      beforeCheck();
    }
  }, []);

  const toPay = async () => {
    // 数据上报
    stat.emit({ eventid: 20030927, act_type: "208" });

    setOrderLoading(true);
    const { code, message, data } = (await fetcher.get(paths.payment, {
      amount: numeral(needPay).format('0.00'),
      callbackUrl: "https://www.yy.com/gi/management/asset/deposit", // 公会中心保证金页面
    })) as PaymentResult;

    if (code === HTTPService.Ok) {
      // 打开支付宝界面
      window.open(data.payUrl, "_blank");
      // 开始轮询界面
      history.replace({
        pathname: ModalRoutes.CheckOrderStatus,
        search: qs.stringify({ orderId: data.id }, { addQueryPrefix: true }),
      });
    } else {
      Toast.info({ text: message || HttpServiceMsg.ServiceError });
      setOrderLoading(false);
    }
  };

  /* 缴纳保证金弹窗 */
  return (
    <Dialog
      wrapperStyle={{ width: "562px" }}
      title=""
      active={bailDialogVisible}
      onCancel={() => history.replace(ModalRoutes.Root)}
      showConfirmBtn={false}
      offsetY={200}
      showCancelBtn={false}
      okTxt="去缴纳"
    >
      <div className="beStar-messagebox">
        <h2>申请成为星级公会</h2>
        <div className="pre">申请为星级，可获得最高30%分成、星级资源包等权益</div>

        {upgradeCode === 9 && (
          <p>近3个月蓝钻不足￥0.3万，您可缴纳3,000.00元保证金，快速成为星级公会</p>
        )}
        {upgradeCode === 10 && <p>您属于非首次升星，还缴纳3,000.00元保证金，快速成为星级公会。</p>}

        <div className="block">
          <div className="field">
            <div className="label">YY保证金账户可用余额</div>
            <div className="field-value">
              <span>{deposit ? thousandSeparator(deposit) : "0.00"} 元</span>
              <Button
                size={ButtonSize.XS}
                type={ButtonType.Emphasis}
                style={{ marginLeft: 15 }}
                loading={accountInfoLoading}
                onClick={fetchAccountInfo}
              >
                刷新
              </Button>
            </div>
          </div>
          <div className="field">
            <div className="label">本次需冻结保证金金额</div>
            <div className="field-value">
              {upgradeAmount ? thousandSeparator(upgradeAmount) : "0.00"} 元
            </div>
          </div>
          <div className="field">
            <div className="label">还需缴纳金额</div>
            <div className="field-value">{needPayStr} 元</div>
          </div>
        </div>
        <div className="tips">
          <p>温馨提示：</p>
          <ol>
            <li>
              <span>缴纳的保证金将从您的保证金账户里进行冻结；</span>
              <span>
                当您降级至普通公会后，公会保证金冻结余额将自动解冻至您的保证金账户可用余额中。
              </span>
            </li>
            <li>成为公会后，将不能成为主播。</li>
          </ol>
        </div>
        <Checkbox checked={check} onChange={setCheck}>
          我已阅读
          <a
            className="tf-ui-link"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open("//www.yy.com/n/6_483.html", "_blank");
            }}
          >
            《YY保证金规则》
          </a>
          并同意缴纳保证金
        </Checkbox>
        <br />
        {/* 如果保证金足够，不需要理会前置检验条件 */}
        {needPay <= 0 ? (
          <Button
            type={ButtonType.Emphasis}
            disabled={!check}
            onClick={beStarGuild}
            loading={beStarGuildLoading}
          >
            去升级
          </Button>
        ) : (
          <Button
            type={ButtonType.Emphasis}
            disabled={!check}
            onClick={toPay}
            loading={orderLoading}
          >
            去缴纳
          </Button>
        )}
      </div>
    </Dialog>
  );
};

export default BeStarModal;
